import { FreightAllowanceAutoCalc, Order } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order';

export class OrderFreightAllowanceController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getSuggestedFreightAllowance(
    order: Order,
  ): Promise<FreightAllowanceAutoCalc> {
    const response = await this.http.post<FreightAllowanceAutoCalc>(
      `freight-allowance/suggested`,
      { order },
    );
    return new FreightAllowanceAutoCalc(response.data);
  }
}
